import React from 'react';
import { Skeleton } from 'antd';
import { selectAuth } from 'app/slice/authSlice';
import { useAppSelector } from 'app/hooks';

const NoPage = () => {
    const { loading } = useAppSelector(selectAuth);
    
    return loading ? (
        <Skeleton active={true} />
    ) : (
        <div className='no-page-content'>404 - ページが見つかりませんでした。</div>
    );
};

export default NoPage;
